import React, { useState, useEffect } from "react";
import { SubscriptionService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { AuthService } from "../../services";
import Avatar from "../../components/Image/AvatarPreview";
import { globalConstant } from "../../constants/globalConstant";
import { routes } from "../../constants/routes";
import { formatDateENGB, handleConsoleError } from "../../utils/common-methods";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { UserRoleType } from "../../constants/Enum";
import { toast } from "react-toastify";

const ActiveSubscription = (props) => {
  const loginUser = AuthService.getLoginUser();
  const navigate = useNavigate();

  const openModal = () => {
    navigate(routes.ACCOUNT_SUBSCRIPTIONPLANS);
  };

  const [activeSubscription, setActiveSubscription] = useState({
    id: "",
    name: "",
    commission: "",
    description: "",
    validity: "",
    startDate: "",
  });

  useEffect(() => {
    // if (loginUser) {
    //   ///getPlan Details
    //   getData();
    // }
    if (loginUser && loginUser?.role === UserRoleType.EO) {
      getData();
    } else {
      navigate(routes.DEFAULT);
    }
  }, []);

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getActiveSubscriptionById(
        loginUser?.id
      );
      if (res?.isSuccess) {
        const sub = {
          id: res?.data?.subscriptionPlanId,
          name: res?.data?.subscriptionPlanName,
          commission: res?.data?.commissionPercentage,
          description: res?.data?.description,
          validity: "Unlimited",
          startDate: formatDateENGB(res?.data?.startDate),
        };
        setActiveSubscription(sub);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message || message);
      
    }
  };
  //  const handleShowModal = () => {};
  return (
    <React.Fragment>
      {/* <Modal isOpen={isModalOpen} onClose={closeModal} size="xl">
        <SubscriptionList></SubscriptionList>
      </Modal> */}
      <section className="bread-head">
        <div className="container">
          <div className="row bread-head3">
            <div className="col-lg-12 col-sm-12">
              <div className="bread-head2">
                <h5>
                  <Link to={routes.ACCOUNT_DASHBOARD}>Account</Link>{" "}
                  <i className="fa-solid fa-chevron-right"></i> Active
                  Subscription
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="edit-form">
        <div className="container">
          <div className="row edit22">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="edit-form2-img">
                <div className="edit-form2-img1">
                  <Avatar
                    altText={
                      loginUser?.firstName?.toUpperCase()[0] +
                      " " +
                      loginUser?.lastName?.toUpperCase()[0]
                    }
                    size={80}
                    borderColor={globalConstant.COLOR_PINK}
                    backgroundColor={globalConstant.COLOR_LITE}
                    imageUrl={loginUser?.profileUrl}
                  />
                </div>
                {/* </div> */}
                <div className="edit-form2-text2">
                  <h3>{loginUser?.firstName + " " + loginUser?.lastName}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {activeSubscription?.name?.length > 2 ? (
        <section className="form-edit55">
          <div className="container edit33">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div className="row">
                  <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                    <h4>Active Plan</h4>
                  </div>
                  <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                    <h5> {activeSubscription?.name}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                    <h4>Commission (%)</h4>
                  </div>
                  <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                    <h5> {activeSubscription?.commission}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                    <h4>Validity</h4>
                  </div>
                  <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                    <h5> {activeSubscription?.validity}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                    <h4>Start Date</h4>
                  </div>
                  <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                    <h5>{activeSubscription?.startDate}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                    <h4>Description</h4>
                  </div>
                  <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                    <h5
                      style={{
                        height: 200,
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          width: "100%", // Make the textarea take up the full width of its container
                          height: "180px", // Set the height of the textarea
                          overflowY: "auto", // Enable vertical scrolling when content overflows
                          resize: "none", // Allow the user to resize the textarea
                        }}
                        dangerouslySetInnerHTML={{
                          __html: activeSubscription?.description,
                        }}
                      />
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="test-edit">
                  <h6>
                    <span onClick={openModal}>
                      <i className="fa-solid fa-pen-to-square"></i> Change
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="form-edit55">
          <div className="container edit33">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div className="edit-label">
                  <div className="edit-label1 edit-last1">
                    <h4>Active Plan</h4>
                  </div>
                  <div className="edit-label11 edit-last2">
                    <h5> Currently, no subscription plan is active.</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="test-edit">
                  <h6>
                    <span onClick={openModal}>
                      <i className="fa-solid fa-pen-to-square"></i> Select Plan
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </React.Fragment>
  );
};

//export default injectModels(["admin", "application"])(Subscription);
export default injectModels(["auth", "application"])(ActiveSubscription);
